<ion-header class="ion-no-border bg">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="back()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Datos fiscales</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-border bg">
  <ion-grid class="app-grid" style="padding: 20px">
    <form [formGroup]="form">
      <ion-row>
        <ion-col size="12">
          <p class="p-normal" style="font-weight: bold">Tipo de contribuyente*</p>
          <ion-row>
            <ion-col size="12" style="padding-top: 10px">
              <ion-radio-group formControlName="taxpayer" style="font-size: 12px" mode="md">
                <ion-radio value="natural" style="position: relative; top: 5px"></ion-radio>
                <span style="padding-left: 5px">Persona física</span>
                <br />
                <ion-radio value="legal" style="position: relative; top: 5px"></ion-radio>
                <span style="padding-left: 5px">Persona moral</span>
                <br />
              </ion-radio-group>
            </ion-col>
          </ion-row>
          <p class="app-input-error" *ngIf="errorData.taxpayer">{{ errorData.taxpayer }}</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <p class="p-normal" style="font-weight: bold">
            {{ form.controls['taxpayer'].value === 'natural' ? 'Nombre y apellidos*' : 'Razón Social*' }}
          </p>
          <div class="app-input">
            <ion-row>
              <ion-col size="12">
                <ion-input
                  class="app-form-input"
                  type="text"
                  placeholder="{{ form.controls['taxpayer'].value === 'natural' ? 'Nombre y apellidos' : 'Razón Social' }}"
                  formControlName="name"
                  [ngClass]="{ 'app-input-danger': errorData.name }"
                ></ion-input>
              </ion-col>
            </ion-row>
          </div>
          <p class="app-input-error" *ngIf="errorData.name">{{ errorData.name }}</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <p class="p-normal" style="font-weight: bold">RFC*</p>
          <div class="app-input">
            <ion-row>
              <ion-col size="12">
                <ion-input
                  class="app-form-input"
                  type="text"
                  placeholder="RFC"
                  formControlName="rfc"
                  [ngClass]="{ 'app-input-danger': errorData.rfc }"
                ></ion-input>
              </ion-col>
            </ion-row>
          </div>
          <p class="app-input-error" *ngIf="errorData.rfc">{{ errorData.rfc }}</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <p class="p-normal" style="font-weight: bold">C.P.*</p>
          <div class="app-input">
            <ion-row>
              <ion-col size="12">
                <ion-input
                  class="app-form-input"
                  type="number"
                  min="0"
                  required="true"
                  minlength="5"
                  maxlength="5"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  placeholder="C.P."
                  formControlName="zip_code"
                  [ngClass]="{ 'app-input-danger': errorData.zip_code }"
                ></ion-input>
              </ion-col>
            </ion-row>
          </div>
          <p class="app-input-error" *ngIf="errorData.zip_code">{{ errorData.zip_code }}</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <p class="p-normal" style="font-weight: bold">Correo electrónico*</p>
          <div class="app-input">
            <ion-row>
              <ion-col size="12">
                <ion-input
                  class="app-form-input"
                  type="text"
                  placeholder="Correo"
                  formControlName="email"
                  [ngClass]="{ 'app-input-danger': errorData.email}"
                ></ion-input>
              </ion-col>
            </ion-row>
          </div>
          <p class="app-input-error" *ngIf="errorData.email">{{ errorData.email }}</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <p class="p-normal" style="font-weight: bold">Uso de CFDI*</p>
          <div class="app-input">
            <ion-row>
              <ion-col size="12">
                <ion-select
                  class="app-form-input"
                  type="text"
                  placeholder="Escoge uno"
                  formControlName="use_cfdi"
                  [ngClass]="{ 'app-input-danger': errorData.use_cfdi }"
                >
                  <ion-select-option *ngFor="let item of cfdis$ | async" [value]="item.key">
                    {{ item.name }}
                  </ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
          </div>
          <p class="app-input-error" *ngIf="errorData.use_cfdi">{{ errorData.use_cfdi }}</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <p class="p-normal" style="font-weight: bold">Régimen*</p>
          <div class="app-input">
            <ion-row>
              <ion-col size="12">
                <ion-select
                  class="app-form-input"
                  type="text"
                  placeholder="Escoge uno"
                  formControlName="tax_regime"
                  [ngClass]="{ 'app-input-danger': errorData.tax_regime }"
                >
                  <ion-select-option *ngFor="let item of regimes$ | async" [value]="item.key">
                    {{ item.name }}
                  </ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
          </div>
          <p class="app-input-error" *ngIf="errorData.tax_regime">{{ errorData.tax_regime }}</p>
        </ion-col>
      </ion-row>
    </form>
  </ion-grid>
</ion-content>

<ion-footer class="ion-no-border bg">
  <ion-toolbar class="ion-no-border bg">
    <ion-grid class="app-grid" style="padding-left: 20px; padding-right: 20px">
      <ion-row>
        <ion-col size="12" class="ion-text-center">
          <ion-button
            mode="ios"
            color="primary"
            expand="full"
            shape="round"
            style="height: 40px"
            [disabled]="load || !form.valid"
            (click)="sendData()"
          >
            Guardar
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
